import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, RawButton, Responsive, Text, useResponsive } from '@common-fe/common-fe';

const TransactionHistoryHint = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [isShowed, setShowed] = useState(true);
  if (!isShowed) {
    return null;
  }
  return (
    <Box
      direction="column"
      data-testid="transaction-history_hint"
      pad={{ horizontal: 'l', vertical: 'm' }}
      background="successContainer"
      round="container1Round"
      margin={{ bottom: 's' }}
      border={{ size: 'small', color: 'successBorder' }}
    >
      <Box direction="row">
        <Box fill>
          <Text weight={700}>{t('Now you can hide small trades!')}</Text>
        </Box>
        <Responsive sizes={[Responsive.Desktop, Responsive.Tablet]}>
          <RawButton data-testid="transaction-history_hint_dismiss-button" onClick={() => setShowed(false)}>
            <Text color="textAccent" weight={400}>
              {t('Dismiss')}
            </Text>
          </RawButton>
        </Responsive>
      </Box>
      <Text>
        {t(
          'Filter your trade activities by setting a minimum amount. This helps you focus on the most impactful transactions.'
        )}
      </Text>
      <Responsive size={Responsive.Mobile}>
        <Box margin={{ top: 'spacing4' }}>
          <RawButton data-testid="transaction-history_hint_dismiss-button" onClick={() => setShowed(false)}>
            <Text color="textAccent" weight={700}>
              {t('Dismiss')}
            </Text>
          </RawButton>
        </Box>
      </Responsive>
    </Box>
  );
};

export default TransactionHistoryHint;
